import React, { useEffect, useState } from 'react';
import { Avatar, Form, InputNumber } from 'antd';
import { SmileOutlined, UserOutlined } from '@ant-design/icons';
import { BaseButtonsForm } from '../../common/forms/BaseButtonsForm/BaseButtonsForm';
import { Input } from '../../common/inputs/Input/Input';
import { Button } from '../../common/buttons/Button/Button';
import { useTranslation } from 'react-i18next';
import * as S from './CreateClassForm.styles';
import { notificationController } from '../../../controllers/notificationController';
import { BaseForm } from '../../common/forms/BaseForm/BaseForm';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { useActions } from '../../../hooks/useActions';
import { IClassesState } from '../../../store/reducers/classes/types';

const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

interface ClassTypeFormData {
  name: string;
  faculty: string;
}

export const CreateClassForm: React.FC = () => {
  const { t } = useTranslation();
const [form] = BaseForm.useForm();
const { createClassRequest, getClassesRequest } = useActions(); 
const { success } = useTypedSelector<IClassesState>(state => state.classes).create;
const [isLoading, setLoading] = useState(false);

useEffect(() => {
  if(success == true){
    form.resetFields();
    onFinish();
    setLoading(false);
    getClassesRequest();
  }
}, [success]);

const onFinish = (values = {}) => {
  setLoading(true);
  setTimeout(() => {
    notificationController.success({ message: t('common:success') });
  }, 1000);
};

const handleSubmit = (values: ClassTypeFormData) => {
    createClassRequest(values);
};
  return (
    <BaseForm form={form} layout="vertical" onFinish={handleSubmit} requiredMark="optional">
        <BaseForm.Item
          name="name"
          label={t('common:name')}
          rules={[{ required: true, message: t('common:requiredField') }]}
        >
          <Input />
        </BaseForm.Item>
        <BaseForm.Item
          name="faculty"
          label={t('classes:faculty')}
          rules={[{ required: true, message: t('common:requiredField') }]}
        >
          <Input />
        </BaseForm.Item>
        <BaseForm.Item>
            <Button htmlType="submit" type="primary" loading={isLoading}>
              {t('common:create')}
            </Button>
          </BaseForm.Item>
      </BaseForm>
  );
};
